import React from 'react';
import { property } from 'underscore';
import { logged_in as loggedIn } from 'state';
import SeoTitleContainer from './seo_title_container';

export default ({ ...rest }) => {
  const { useSelector } = window.reactRedux;

  if (loggedIn()) return <SeoTitleContainer {...rest} />;

  const { fetching, heading } = useSelector(property('seo')) || {};

  if (fetching) return null;
  return <SeoTitleContainer {...rest} seoHeading={heading} />;
};
